import { render, staticRenderFns } from "./WithdrawSuccess.vue?vue&type=template&id=58461adb"
import script from "./WithdrawSuccess.vue?vue&type=script&lang=js"
export * from "./WithdrawSuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports